<ng-progress [showSpinner]="true"></ng-progress>
<app-nav-bar class="no-print"></app-nav-bar>
<div class="container-fluid" style="padding-top: 0.75rem">
    <router-outlet></router-outlet>
</div>
